import type { BoostTimerFragment } from "@workspace/casino_core/queries/BoostNotificationQuery";
import Link from "@workspace/casino_pages/legacyLayer/client/components/Link";
import Translation from "@workspace/casino_pages/legacyLayer/client/components/Translation";
import ClaimButton from "@/ui/Games/CasinoBoostNotification/ClaimButton";

type Props = {
  boost: BoostTimerFragment;
  context: WorkerContext;
  onClose: () => void;
};

const Footer: FC<Props> = ({ boost, context, onClose }) => (
  <div className="mt-3 grid gap-4">
    <ClaimButton
      boost={boost}
      translations={context.translations}
      onClose={onClose}
    />
  </div>
);

export default Footer;
